<div class="terms-dialog">
  <div class="terms-header">
    <h2 mat-dialog-title>Termini e Condizioni</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content #termsContent class="terms-content">
    <div #termsContainer class="terms-container"></div>
  </mat-dialog-content>

  <div class="terms-footer" [class.visible]="hasScrolledToBottom">
    <mat-checkbox
      [(ngModel)]="hasAcceptedTerms"
      color="primary"
      (change)="onCheckboxChange()"
    >
      Ho letto e accetto i Termini e le Condizioni
    </mat-checkbox>

    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>Annulla</button>
      <button
        mat-raised-button
        color="primary"
        [disabled]="!hasAcceptedTerms"
        (click)="acceptTerms()"
      >
        Accetta e Continua
      </button>
    </mat-dialog-actions>
  </div>
</div>
